import { render } from "./TopTrafficSources.vue?vue&type=template&id=052a54cc&scoped=true"
import script from "./TopTrafficSources.vue?vue&type=script&lang=js"
export * from "./TopTrafficSources.vue?vue&type=script&lang=js"

import "./TopTrafficSources.vue?vue&type=style&index=0&id=052a54cc&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-052a54cc"]])

export default __exports__